module.exports = __webpack_public_path__ + "static/media/jul.3b055ffd.jpg";